module.exports = __webpack_public_path__ + "img/P150T_weapon_8.0a3213dc.png";